import {Validators} from '@angular/forms';

import {SelectControl} from '../../../app/shared/classes';
import {ComponentTypesEnum} from '../../../app/shared/enums/common';

export const ProofOfIdentityDocumentTypeSelector = 'documentType';
export const ProofOfAddressDocumentTypeSelector = 'addressType';

export const ProofOfIdentityControl = (): SelectControl => {
    return new SelectControl({
        name: ProofOfIdentityDocumentTypeSelector,
        value: null,
        placeholder: 'Document type',
        validators: [Validators.required],
        componentType: ComponentTypesEnum.Select,
        options: []
    });
};

export const ProofOfAddressControl = (): SelectControl => {
    return new SelectControl({
        name: ProofOfAddressDocumentTypeSelector,
        value: null,
        placeholder: 'Document type',
        validators: [Validators.required],
        componentType: ComponentTypesEnum.Select,
        options: []
    });
};
